import { getReactionImageUrl } from '../ConditionsService';

const reactionImageCache = new Map();
const reactionImagePromiseCache = new Map();

export function clearConditionsReactionImageCache() {
  reactionImageCache.clear();
  reactionImagePromiseCache.clear();
}

function getStringHash(value = '') {
  let hash = 5381;

  for (let i = 0; i < value.length; i += 1) {
    hash = (Math.imul(hash, 33) + value.charCodeAt(i)) % 2147483647;
  }

  return hash.toString(36);
}

function getCacheKey(reaction, imageType) {
  return `${imageType}:${reaction.length}:${getStringHash(reaction)}`;
}

export function getCachedReactionImageUrl(reaction, imageType) {
  const cacheKey = getCacheKey(reaction, imageType);

  if (reactionImageCache.has(cacheKey)) return Promise.resolve(reactionImageCache.get(cacheKey));
  if (reactionImagePromiseCache.has(cacheKey)) return reactionImagePromiseCache.get(cacheKey);

  const imagePromise = getReactionImageUrl(reaction, imageType);
  reactionImagePromiseCache.set(cacheKey, imagePromise);

  return imagePromise
    .then((imageUrl) => {
      if (imageUrl) reactionImageCache.set(cacheKey, imageUrl);
      return imageUrl;
    })
    .finally(() => {
      reactionImagePromiseCache.delete(cacheKey);
    });
}

export function getCachedImageUrlIfAvailable(reaction, imageType) {
  const cacheKey = getCacheKey(reaction, imageType);

  return {
    isCached: reactionImageCache.has(cacheKey),
    imageUrl: reactionImageCache.get(cacheKey),
  };
}
